import React, { useState, useEffect } from 'react';

/* Listens for the custom 'showToast' window event dispatched by the Contact form. */
export default function Toast() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handler = () => {
      setShow(true);
      setTimeout(() => setShow(false), 3500);
    };
    window.addEventListener('showToast', handler);
    return () => window.removeEventListener('showToast', handler);
  }, []);

  return (
    <div className={`toast ${show ? 'show' : ''}`}>
      ✓ ENQUIRY SENT — WE'LL CALL YOU BACK WITHIN 24 HOURS
    </div>
  );
}
